// extracted by mini-css-extract-plugin
export default {"createpaper":"CreatePaper_createpaper__aZizu","cp-btn":"CreatePaper_cp-btn__YODE5","btn-sec":"CreatePaper_btn-sec__WccRe","btn":"CreatePaper_btn__fulyZ"};